(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-level-care', {
                parent: 'entity',
                url: '/type-level-care',
                data: {
                    authorities: [],
                    pageTitle: 'TypeLevelCares'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-level-care/list/type-level-care.html',
                        controller: 'TypeLevelCareController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LEVEL_OF_CARE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LEVEL_OF_CARE, access);
                }]
            });
    }
})();
